import React from 'react';
import { Provider } from 'react-redux';
import store from '../store/store';

const ReduxContainer = ({ children }) => {
  return (
    <Provider store={store}>
      {children}
    </Provider>
  );
};

export default ReduxContainer;
